<template>
  <section class="inventory-master-data">
    <div class="inventory-master-data__tabs" role="tablist" aria-label="Master data inventori">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        role="tab"
        class="inventory-master-data__tab"
        :class="{ 'inventory-master-data__tab--active': activeTab === tab.key }"
        :aria-selected="activeTab === tab.key ? 'true' : 'false'"
        @click="selectTab(tab.key)"
      >
        <i :class="tab.icon" aria-hidden="true"></i>
        <span>{{ tab.label }}</span>
      </button>
    </div>

    <keep-alive>
      <component :is="activeComponent" :key="activeTab" />
    </keep-alive>
  </section>
</template>

<script>
import InventoryCategory from "@/view/pages/inventory/Category.vue";
import WarehouseList from "@/view/pages/masters/warehouses/List.vue";
import UomList from "@/view/pages/masters/uoms/List.vue";
import VendorList from "@/view/pages/masters/vendors/List.vue";

export default {
  name: "InventoryMasterData",
  components: {
    InventoryCategory,
    WarehouseList,
    UomList,
    VendorList,
  },
  data() {
    return {
      tabs: [
        { key: "categories", label: "Kategori", icon: "fas fa-tags", component: "InventoryCategory" },
        { key: "warehouses", label: "Gudang", icon: "fas fa-warehouse", component: "WarehouseList" },
        { key: "units", label: "Satuan", icon: "fas fa-balance-scale", component: "UomList" },
        { key: "suppliers", label: "Supplier", icon: "fas fa-truck-loading", component: "VendorList" },
      ],
    };
  },
  computed: {
    activeTab() {
      const requested = this.$route.query.tab;
      return this.tabs.some((tab) => tab.key === requested) ? requested : "categories";
    },
    activeComponent() {
      return this.tabs.find((tab) => tab.key === this.activeTab).component;
    },
  },
  methods: {
    selectTab(tab) {
      if (tab === this.activeTab && this.$route.query.tab) return;
      this.$router.replace({
        path: "/inventory/master-data",
        query: { tab },
      });
    },
  },
};
</script>

<style scoped>
.inventory-master-data__tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  padding: 7px;
  overflow-x: auto;
  background: #ffffff;
  border: 1px solid #e4eaf1;
  border-radius: 14px;
  box-shadow: 0 6px 18px rgba(20, 50, 99, 0.06);
}

.inventory-master-data__tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 125px;
  padding: 10px 16px;
  gap: 8px;
  color: #65758b;
  background: transparent;
  border: 0;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  transition: 0.18s ease;
}

.inventory-master-data__tab:hover,
.inventory-master-data__tab:focus-visible {
  color: #14608f;
  background: #f0f7fa;
  outline: none;
}

.inventory-master-data__tab--active {
  color: #ffffff;
  background: linear-gradient(135deg, #14608f, #1e958f);
  box-shadow: 0 5px 12px rgba(20, 96, 143, 0.2);
}

@media (max-width: 767px) {
  .inventory-master-data__tab {
    min-width: 108px;
    padding: 9px 12px;
  }
}
</style>
